import { SyntheticEvent } from 'react';
import { Tab, Tabs } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { generatePath, useNavigate, useParams } from 'react-router-dom';
import { InvoiceTab, reactPaths } from 'root/pathnames';

export const InvoicesTabs = () => {
  const { tab: invoiceTab } = useParams<{ tab: InvoiceTab }>();
  const { t } = useTranslation(['invoice']);

  const navigate = useNavigate();

  const handleChange = (_: SyntheticEvent, value: InvoiceTab) => {
    navigate(
      generatePath(reactPaths.invoicesModule, {
        tab: value,
      }),
    );
  };

  return (
    <Tabs value={invoiceTab} onChange={handleChange}>
      <Tab label={t('ownTab', { ns: 'invoice' })} value={InvoiceTab.OWN} />
      <Tab
        label={t('foreignTab', { ns: 'invoice' })}
        value={InvoiceTab.FOREIGN}
      />
      <Tab
        label={t('administrativeTab', { ns: 'invoice' })}
        value={InvoiceTab.ADMINISTRATIVE}
      />
      <Tab
        label={t('internalTab', { ns: 'invoice' })}
        value={InvoiceTab.INTERNAL}
      />
    </Tabs>
  );
};
